var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusPink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.09375 1.75C7.09375 1.42208 6.82792 1.15625 6.5 1.15625C6.17208 1.15625 5.90625 1.42208 5.90625 1.75V5.90625H1.75C1.42208 5.90625 1.15625 6.17208 1.15625 6.5C1.15625 6.82792 1.42208 7.09375 1.75 7.09375H5.90625V11.25C5.90625 11.5779 6.17208 11.8438 6.5 11.8438C6.82792 11.8438 7.09375 11.5779 7.09375 11.25V7.09375H11.25C11.5779 7.09375 11.8438 6.82792 11.8438 6.5C11.8438 6.17208 11.5779 5.90625 11.25 5.90625H7.09375V1.75Z",
    fill: "#FF0990",
    stroke: "#FF0990",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusPink);
export default __webpack_public_path__ + "static/media/plus-pink.ace03345493f5544660ea3285f256b98.svg";
export { ForwardRef as ReactComponent };